import center from '@turf/center';
import { getCoord } from '@turf/invariant';

/*
 * In lack of a better name, common holds some standard functions
 * Mostly leftovers from vendors/misc
 */



/*
 * detect CSS text-shadow support in JavaScript
 * http://www.sitepoint.com/detect-css3-property-browser-support/
 * another requirement for L.BuildingLabel
 */
var hasTextShadow = function(){
     return (document.createElement("detect").style.textShadow === "");
};


var getCookie = function(w){
    var cName = "", pCOOKIES = [], nameVal = [];
    pCOOKIES = document.cookie.split('; ');
    for(var bb = 0; bb < pCOOKIES.length; bb++){
        nameVal  = [];
        nameVal  = pCOOKIES[bb].split('=');
        if(nameVal[0] === w){
            cName = unescape(nameVal[1]);
        }
    }

    if(cName === 'null' || cName === ''){
        return null;
    }
    if(cName === 'false'){
        return false;
    }
    if(cName === 'true'){
        return true;
    }
    return cName;
}

var setCookie = function(c_name,value,expiredays) {
    var escape = window.encodeURI;
    if(!escape){
        return;
    }

    var c_str = escape(value);
    if (expiredays) {
        var exdate=new Date();
        exdate.setDate(exdate.getDate()+expiredays);
        c_str += "; expires="+exdate.toUTCString();
    }
    document.cookie=c_name+ "=" + c_str;
};

var eraseCookie = function(c_name) {
    setCookie(c_name, '', -1);
};


// Minified: only 160 bytes!
//http://davidwalsh.name/javascript-debounce-function
var debounce = function(a,b,c){var d;return function(){var e=this,f=arguments; clearTimeout(d),d=setTimeout(function(){d=null,c||a.apply(e,f)},b),c&&!d&&a.apply(e,f)}}

// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
// be appended at the end. If `uppercase` is `true`, the parameter names will
// be uppercased (e.g. `'?A=foo&B=bar'`)
var getParamString = function(obj, existingUrl, uppercase) {
    var params = [];
    for (var i in obj) {
        params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
    }
    return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
}

var getFeatureCenterLngLat = function(poiFeature){
    var point = center(poiFeature);
    var coords = getCoord(point);
    var lngLat = {lng: coords[0], lat: coords[1]}
    return lngLat;
};

module.exports = {
    getFeatureCenterLngLat: getFeatureCenterLngLat,
    hasTextShadow: hasTextShadow,
    getCookie: getCookie,
    setCookie: setCookie,
    eraseCookie: eraseCookie,
    debounce: debounce,
    getParamString: getParamString
};



// WEBPACK FOOTER //
// src/utils/Common.js